import React from 'react';

/**
 * A tooltip's content, split so it reads at a glance: a short bold heading,
 * a few short lines, and a list when there's one (e.g. each year's area).
 */
export interface TipText {
  title?: string;
  lines?: string[];
  items?: string[];
}

/** The same content as one string — for a screen reader's label. */
export const tipToText = (tip: string | TipText): string =>
  typeof tip === 'string'
    ? tip
    : [tip.title, ...(tip.lines ?? []), ...(tip.items ?? [])]
        .filter(Boolean)
        .join('. ');

const TipContent: React.FC<{ tip: string | TipText }> = ({ tip }) => {
  if (typeof tip === 'string') return <>{tip}</>;
  return (
    <div className="flex flex-col gap-1">
      {tip.title && <p className="font-semibold">{tip.title}</p>}
      {tip.lines?.map((line) => <p key={line}>{line}</p>)}
      {tip.items && tip.items.length > 0 && (
        <ul className="flex flex-col">
          {tip.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TipContent;
